"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return (/^((mailto:[^<>()/[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-anchor-plugin/lib/utils/mailRegex.js
// module id = 1029
// module chunks = 0